import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { styles } from '../../styles';

interface IErrorInfoMessageProps {
  error: string;
}

export const ErrorInfoMessage = ({ error }: IErrorInfoMessageProps) => {
  return (
    <Box sx={styles.errorInfoMessage}>
      <InfoOutlined color="error" />
      <Typography variant="body2" sx={{ color: 'error.main', bottom: -14 }}>
        {error}
      </Typography>
    </Box>
  );
};
